import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Pulsing "NEW" badge for freshly-added products.
 * Sits absolutely positioned via wrapper.
 */
export const NewBadge = ({ size = 'md' }) => {
  const sizes = {
    sm: { px: 'px-2 py-0.5', text: 'text-[9px]', icon: 'h-2.5 w-2.5' },
    md: { px: 'px-2.5 py-1', text: 'text-[10px]', icon: 'h-3 w-3' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span
      data-testid="new-badge"
      className={`relative inline-flex items-center gap-1 ${s.px} rounded-full font-extrabold uppercase tracking-widest ${s.text}`}
      style={{
        background: 'linear-gradient(135deg, #F5E6D3 0%, #D4A373 60%, #B5895F 100%)',
        color: '#0C0A09',
        boxShadow:
          '0 4px 14px rgba(212, 163, 115, 0.55), 0 0 0 1px rgba(255, 215, 170, 0.4) inset',
      }}
    >
      {/* Pulsing ring */}
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full"
        style={{
          boxShadow: '0 0 0 0 rgba(212, 163, 115, 0.6)',
          animation: 'new-badge-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        }}
      />
      <Sparkles className={`${s.icon} relative`} strokeWidth={2.5} />
      <span className="relative">New</span>
    </span>
  );
};

export default NewBadge;
